module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.66a68ff.woff";